import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SSOCALLBACK, STATUS, LOCALSTORAGENAME } from "../../data/constants";
import { USERSIGNINMESSAGES } from "../../constants/messages";
function SSOCallback() {
  const location = useLocation();

  useEffect(() => {
    const query = new URLSearchParams(location.search);

    const token = query.get(SSOCALLBACK.TOKEN);
    const userId = query.get(SSOCALLBACK.USERID);
    const userName = query.get(SSOCALLBACK.USERNAME);
    const firstName = query.get(SSOCALLBACK.FIRSTNAME);
    const lastName = query.get(SSOCALLBACK.LASTNAME);
    const responseMessage = query.get(SSOCALLBACK.RESPONSEMSG);
    let roleNames = "";
    const search = location.search;
    const roleIndex = search.indexOf(SSOCALLBACK.ROLENAMES + "=");
    if (roleIndex !== -1) {
      roleNames = search.substring(roleIndex + (SSOCALLBACK.ROLENAMES + "=").length);
      roleNames = decodeURIComponent(roleNames);
    }
    localStorage.setItem(
      LOCALSTORAGENAME.ISFIRSTTIMELOGIN,
      (query.get(SSOCALLBACK.ISFIRSTTIMELOGIN) || "false").toLocaleLowerCase(),
    );

    if (window.opener) {
      window.opener.postMessage(
        {
          status: token ? STATUS.SUCCESS : STATUS.ERROR,
          token,
          userId,
          userName,
          firstName,
          lastName,
          roleNames,
          responseMessage,
        },
        window.location.origin,
      );
    }
    window.close();
  }, [location]);

  return (
    <>
      <div>{USERSIGNINMESSAGES.SSO_LOGGING}</div>
    </>
  );
}

export default SSOCallback;
